module.exports = __webpack_public_path__ + "img/mesto3b.29d3578c.png";